import {ControllerFieldState} from 'react-hook-form';

export type InputStateType = 'default' | 'filled' | 'error' | 'valid';

interface GetInputStateParams {
    fieldState?: ControllerFieldState;
    value: any;
    validate: boolean;
}

export const getInputState = ({
    fieldState,
    value,
    validate,
}: GetInputStateParams): InputStateType => {
    if (!value) return 'default';
    if (fieldState?.error) return 'error';
    if (!validate && !fieldState?.error) return 'filled';
    if (!fieldState?.isDirty && !fieldState?.invalid) return 'valid';
    if (fieldState?.isDirty && !fieldState?.error) return 'valid';

    return 'filled';
};